export enum Action {
  Redaction = 1,
  StudyStartup = 2,
  CollaborationReviewer = 3,
  CollaborationAdministrator = 4,
  PageManipulations = 5,
  ESignature = 6,
  UserLookup = 7,
  OnlineEdit = 8, // deleted on server
  Communication = 9,
  IndexModification = 10,
  DocumentsDistribution = 11,
  EventManager = 12,
  AssignTasks = 13,
  DocumentManager = 14,
  CraReconciliation = 15,
  EnrollForGlCourses = 16,
  CRA = 17,
  Translations = 18,
  Acknowledgment = 19,
  QualityRecordsModule = 20,
  CreateIncident = 21,
  CreateCAPA = 22,
  RestrictDocumentsCreation = 23,
  ManageRecordAssignments = 24,
  CreateQualification = 25,
  CreateAudit = 26,
  CreateActionItem = 27,
}
